<nice-layout
    *resolve="currentAccount$ | async as currentAccount"
    class="overflow-x-hidden h-screen print:h-full"
    [class.bg-blue-to-green]="currentAccount?.role === 'owner'"
>
    <ng-container *ngIf="currentAccount === null ? false : currentAccount.role !== 'owner' || !useOwnerHomeCustomNav">
        <!-- Navigation -->
        <!-- FVI: The old UI use the nerri-navbar -->
        <nerri-navbar [isSmallScreen]="(isSmallScreen$ | async) !== false" />

        <!-- Wrapper -->
        <div class="relative flex flex-col w-full min-w-0 flex-auto overflow-x-hidden">
            <div
                *ngIf="currentAccount === null ? false : currentAccount.role !== 'owner'"
                class="absolute left-0 top-0 h-60 w-full bg-primary print:hidden"
            ></div>

            <!-- Header -->
            <div
                *ngIf="(isSmallScreen$ | async) === false && currentAccount?.role === 'owner'"
                class="relative z-49 flex h-16 w-full flex-0 items-center px-4 md:hidden print:hidden"
            >
                <!-- Navigation toggle button -->
                <div class="lg:hidden">
                    <button mat-icon-button (click)="toggleNavigation('mainNavigation')">
                        <mat-icon>menu</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Content -->
            <div
                class="flex flex-auto flex-col px-8 py-8 2xl:px-16 2xl:py-11 print:p-0"
                [niceLoadingOverlay]="loading$ | async"
            >
                <panko-breadcrumb
                    class="z-50 pb-10 print:hidden"
                    [class.hidden]="currentAccount === null ? false : currentAccount.role === 'owner' || shouldHideBreadcrumb"
                />
                <router-outlet />
            </div>
        </div>

        <div class="sticky inset-0 h-screen z-10 print:hidden">
            <ng-template [cdkPortalOutlet]="drawerPortal$ | async" />
        </div>
    </ng-container>

    <div *ngIf="currentAccount?.role === 'owner' && useOwnerHomeCustomNav" class="flex flex-col w-full min-w-0">
        <nerri-citizen-navbar class="w-full print:hidden" [isSmallScreen]="(isSmallScreen$ | async) !== false" />

        <div class="flex flex-col p-4 xl:p-8 overflow-auto print:p-0">
            <router-outlet />
        </div>
    </div>
</nice-layout>
